<template>
  <div class="nav">
    <van-nav-bar :title="title" left-text="返回" left-arrow @click-left="onClickLeft" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      // title: '标题',
      title:this.$route.name
    }
  },
  methods: {
    onClickLeft() {
      history.go(-1);
    }
  }
}
</script>
<style>
.nav {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 46px;
}
.nav .van-nav-bar__title{
  font-size: 14px;
}
</style>